module.exports = __webpack_public_path__ + "img/article612.5b32cddd.jpg";